import axios from "axios";
import API_BASE_URL from "config/api";

const adminClient = axios.create({
  baseURL: API_BASE_URL,
});

const attachAuthToken = (config) => {
  const token = sessionStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

const handleUnauthorized = (error) => {
  if (error.response?.status === 401) {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("SubscriptionPlansData");
    sessionStorage.removeItem("UserListData");
    sessionStorage.removeItem("SubscriptionsList");
    window.location.href = "/sign-in";
  }
  return Promise.reject(error);
};

adminClient.interceptors.request.use(attachAuthToken);
adminClient.interceptors.response.use((response) => response, handleUnauthorized);

export { adminClient };
